import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BreakoutAlerts from '../../pages/breakout-alerts';

const BreakoutAlertsFullWidget = (props) => {
  const queryClient = new QueryClient();
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');
    const fullWidget = window.location.pathname.includes('breakout-alerts-full');

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setLightMode(true);
      setDarkMode(false);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.style.overscrollBehaviorY = 'auto';
    if (disabledm === '1') {
      body.style.backgroundColor = '#FFFFFF';
    } else if (
      dm === '1' ||
      (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      body.style.backgroundColor = '#2B2B2B';
    }
    if (fullWidget && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      body.style.backgroundColor = '#181818';
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BreakoutAlerts
        fullWidget={true}
        widget={true}
        darkMode={darkMode}
        lightMode={lightMode}
        {...props}
      />
    </QueryClientProvider>
  );
};

export { BreakoutAlertsFullWidget };
